import React , {Component} from "react";
import "./Header.css";
import {FaAlignRight, FaShoppingCart, FaHeart, FaHotel , FaUser} from "react-icons/fa";
import {ImHome} from "react-icons/im";
import {Link, NavLink , withRouter} from "react-router-dom";
import {RoomContext} from "../../Context";
import $ from "jquery";
const logo = require("../../images/logo.svg");

class Header extends Component {
    
   componentDidMount=()=>{
    $(".navbar-nav .navigation-link").on("click",()=>{
        $(".navbar-collapse").removeClass("show");
    });
   }
    static contextType = RoomContext;
    render(){
        let {favRooms, cartRooms , notificationMSG , showNotification} = this.context;
            return(
            <header className="header">
                <div className="container headerInner">
                    <nav className="navbar navbar-expand-sm w-100">
                        <Link className="nav-mylink" to="/">
                            <img className="navbar-brand" src={logo} alt="logo" />
                        </Link>

                        <button className="navbar-toggler" data-toggle="collapse" data-target="#mainNav">
                            <FaAlignRight className="nav-icon"/>
                        </button>
                        <div className="navbar-collapse collapse" id="mainNav">
                            <ul className="navbar-nav mr-auto" >
                                <NavLink exact to="/"   activeClassName="active" className="nav-link navigation-link" tag="li"><ImHome className="nav-icons"/> Home</NavLink>
                                <NavLink to="/rooms"  activeClassName="active" className="nav-link navigation-link" tag="li"><FaHotel className="nav-icons"/>  Rooms</NavLink>
                                <NavLink to="/signin"  activeClassName="active" className="nav-link navigation-link" tag="li"><FaUser className="nav-icons"/> Sign In</NavLink>
                            </ul>
                            <ul className="shopping-deck">
                                <div className="header-icons">
                                    <NavLink exact to="/favs" tag="li"  className="navigation-link ico"><FaHeart/></NavLink>
                                    {favRooms.length >=1 && this.props.location.pathname !=="/favs" ? <Link to="/favs"  className="items-counter">{favRooms.length}</Link> : null}
                                </div>
                                <div className="header-icons">
                                    <NavLink exact to="/cart" tag="li"  className="navigation-link ico"><FaShoppingCart/></NavLink>
                                    {cartRooms.length >= 1 && this.props.location.pathname !=="/cart" ?  <Link to="/cart"  className="items-counter">{cartRooms.length}</Link> : null}
                                </div>
                            </ul>
                        </div>
                        
                        
                    </nav>
                </div>
                {
                    showNotification
                    ?
                        <div className={`alert alert-${notificationMSG.mode} py-1 px-4 noti-MSG`}>
                            <p>{notificationMSG.message}</p>
                        </div>
                    :
                    null
                }
            </header>
        )
    }
    
};

export default withRouter(Header);